
import React from 'react';
import FilamentManager from './FilamentManager';
import ManufacturerManager from './ManufacturerManager';
import PrinterManager from './PrinterManager';
import TutorialManager from './TutorialManager';
import PageAccessControl from './PageAccessControl';

interface FilamentManagementContentProps {
  searchQuery: string;
  selectedManufacturer: string;
  selectedType: string;
  selectedStatus: string;
  activeSection: 'filaments' | 'manufacturers' | 'printers' | 'tutorials' | 'page-access';
}

const FilamentManagementContent = ({
  searchQuery,
  selectedManufacturer,
  selectedType,
  selectedStatus,
  activeSection
}: FilamentManagementContentProps) => {
  const renderContent = () => {
    switch (activeSection) {
      case 'filaments':
        return (
          <FilamentManager
            searchQuery={searchQuery}
            selectedManufacturer={selectedManufacturer}
            selectedType={selectedType}
            selectedStatus={selectedStatus}
          />
        );
      case 'manufacturers':
        return (
          <ManufacturerManager
            searchQuery={searchQuery}
            selectedStatus={selectedStatus}
          />
        );
      case 'printers':
        return (
          <PrinterManager
            searchQuery={searchQuery}
            selectedManufacturer={selectedManufacturer}
            selectedStatus={selectedStatus}
          />
        );
      case 'tutorials':
        return (
          <TutorialManager
            searchQuery={searchQuery}
            selectedStatus={selectedStatus}
            selectedType={selectedType}
          />
        );
      case 'page-access':
        return <PageAccessControl />;
      default:
        return <div>Select a section to manage</div>;
    }
  };

  return (
    <div className="space-y-6">
      {renderContent()}
    </div>
  );
};

export default FilamentManagementContent;
